module.exports = __webpack_public_path__ + "media/assets/img/btn_strava_connectwith_orange-056a1d4f541c373c46602895b7565751.png";